// extracted by mini-css-extract-plugin
export default {"pairs":"styles_pairs__BSuOt","pair":"styles_pair__uzhHx","text":"styles_text__Dabw-","pairsCount":"styles_pairsCount__+iC0e"};